/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */
/* eslint-disable no-nested-ternary */

import "phaser";
import { Button } from "./../Entities/GlobalEntities"
import { getTopScores, getMyAddress } from "../../../web3/SFM-ScoreBoardContract_Utils";
import { AddImageToScene, getRandomInt, loadAudio, loadImage ,processData } from "./../modules/utiltes"
import { SoundManager } from "../ScenesHelpers/SoundManager";
import {
    getAllTeams,
    getMyTeam
} from "../../../web3/SFM-TeamsUtils";
let allScores;
const commonStyle = {
    fontFamily: "monospace",
    fontStyle: "bold",
    color: "#ffffff",
    align: "center",
}


export class SceneTopScoresMenu extends Phaser.Scene {
    constructor() {
        super({
            key: "SceneTopScoresMenu",
        });
    }
    init(data) {
        this.mode = data.mode;
    }
    preload() {
        loadImage(this, "topscoremenu", "assets/img/game/Background-2.png")
        loadImage(this, 'stargametbtn', 'assets/img/game/StartGame.png')
        loadAudio(this, "topscoresmenu", "assets/img/game/topscores.wav");
        loadImage(this, 'loadingscene', `assets/img/game/BG ${getRandomInt(19)}.jpg`)
    }

    async create() {

        this.dataPoints = await processData(this.mode);
      
        this.sfx = {
            topscores: SoundManager.createAudio(this, "topscoresmenu", 1, false)
        };
        
        this.sfx.topscores.play();

        this.bg = AddImageToScene(this, "topscoremenu")
        this.input.keyboard.removeCapture(Phaser.Input.Keyboard.KeyCodes.W);
        this.input.keyboard.removeCapture(Phaser.Input.Keyboard.KeyCodes.S);
        this.input.keyboard.removeCapture(Phaser.Input.Keyboard.KeyCodes.A);
        this.input.keyboard.removeCapture(Phaser.Input.Keyboard.KeyCodes.D);
        this.title = this.add.text(
            this.game.config.width * 0.5,
            128,
            "TOP SCORES", {
                fontFamily: commonStyle.fontFamily,
                fontSize: 48,
                fontStyle: commonStyle.fontStyle,
                color: commonStyle.color,
                align: commonStyle.align,
            }
        );
        this.title.setOrigin(0.5);
        this.stargametbtn = new Button(
            this,
            250,
            600,
            "stargametbtn"

        )
        this.stargametbtn.setInteractive()
        this.stargametbtn.on('pointerdown', function(pointer) {

            this.setTint(0x6B128B);

        });
        this.stargametbtn.on('pointerup', (pointer) => {

            this.scene.start('SceneIntro')

        });
        this.stargametbtn.on('pointerout', function(pointer) {

            this.clearTint();

        });

        const MAX_RENDERED_TEAMS = 5;
        let height = 0.3;
        const minLen = Math.min(this.dataPoints.length, MAX_RENDERED_TEAMS);
        for (let i = 0; i < minLen; i++) {
            let result = this.dataPoints[i];
            const title = this.mode === "off" ? result.address : result.name;
            this.add.text(
                this.game.config.width * 0.3,
                this.game.config.height * height,
                `${title}: ${result.score.toString()}`, {
                    fontFamily: commonStyle.fontFamily,
                    fontSize: 20,
                    fontStyle: commonStyle.fontStyle,
                    color: commonStyle.color,
                    align: commonStyle.align,
                }
            );
            height += 0.1;
        }
    }

    update() {}
}